import React, {Component} from 'react';
import {PRIORITY_HIGH, PRIORITY_LOW, PRIORITY_MEDIUM, PRIORITY_NONE, PRIVACY_PRIVATE, PRIVACY_PUBLIC} from "./utils";
import {byPropKey} from "../utils";
import PriorityLevel from "./information/PriorityLevels";
import ReactToolTip from 'react-tooltip';
import {getFormattedRecordingTitle} from "../unit/recordings/utils";
import {getFormattedDateForTitle} from "../../utils/date";
import Runtime from "./information/Runtime";
import Size from "./information/Size";
import Speed from "./information/Speed";
import PrivacyLevels from "./information/PrivacyLevels";
import {getUnitName} from "../unit/utils";

const INITIAL_STATE = {
    title: null,
    description: null,
    priority: null,
    privacy: null,
    error: null
};

const TOOLTIP_PRIVACY_ID = 'privacyTip';
const TOOLTIP_PRIORITY_ID = 'priorityTip';

class RecordingForm extends Component {
    constructor() {
        super();
        this.state = {
            ...INITIAL_STATE
        };
    }

    componentDidMount() {
        this.resetStateToProps();
    }

    resetStateToProps = () => {
        this.setState(byPropKey('title', getFormattedRecordingTitle(this.props.recording)));
        this.setState(byPropKey('description', this.props.recording.description || ""));
        this.setState(byPropKey('priority', this.props.recording.priority || PRIORITY_NONE));
        this.setState(byPropKey('privacy', this.props.recording.privacy || PRIVACY_PRIVATE));
    };

    onSubmit = (event) => {
        event.preventDefault();
    };

    componentWillUpdate(nextProps, nextState) {
        if (this.state.title !== nextState.title ||
            this.state.description !== nextState.description ||
            this.state.priority !== nextState.priority ||
            this.state.privacy !== nextState.privacy) {
            this.props.onFieldChange({
                title: nextState.title,
                description: nextState.description,
                priority: nextState.priority,
                privacy: nextState.privacy
            });
            // TODO: Tagging?
        }
        if (this.props.editModeOn !== nextProps.editModeOn) {
            this.resetStateToProps();
        }
    }

    render() {
        return this.props.recording && this.props.unit ? (
            <form>
                {
                    (this.props.editModeOn)
                        ? <div className="form-group">
                            <label htmlFor="txtTitle">Title: </label>
                            <input
                                id="txtTitle"
                                className="form-control input-lg"
                                value={this.state.title}
                                type="text"
                                onChange={event => this.setState(byPropKey('title', event.target.value))}
                                placeholder="Title (Optional, 120 characters max)"
                                disabled={!this.props.editModeOn}
                            />
                        </div>
                        : <h3 style={{wordWrap: 'break-word'}}>{getFormattedRecordingTitle(this.props.recording)}</h3>
                }
                {
                    !this.props.editModeOn &&
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 text-muted small">{getFormattedDateForTitle(this.props.recording.date)}</div>
                        <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 text-muted small">{getUnitName(this.props.unit)}</div>
                    </div>
                }
                {
                    (this.props.editModeOn)
                        ? <div className="form-group">
                            <label htmlFor="txtDescription">Description: </label>
                            <textarea
                                id="txtDescription"
                                className="form-control input-lg"
                                value={this.state.description}
                                rows="4"
                                onChange={event => this.setState(byPropKey('description', event.target.value))}
                                placeholder="Description (Optional, 500 characters max)"
                                disabled={!this.props.editModeOn}
                            />
                        </div>
                        : <p>{this.props.recording.description}</p>
                }
                {
                    (this.props.editModeOn) &&
                    <div className="form-group form-inline">
                        <label className="mr-1" htmlFor="lstPriority">
                            Priority <span data-tip data-for={TOOLTIP_PRIORITY_ID}><i className="ml-1 far fa-question-circle"/></span>:
                            <ReactToolTip id={TOOLTIP_PRIORITY_ID}>
                                <div>The estimated level of importance of the recording.</div>
                                <ul>
                                    <li><b>High</b>: he recording was automatically uploaded after a strong impact.</li>
                                    <li><b>Medium</b>: The recording was automatically uploaded after a medium impact.</li>
                                    <li><b>Low</b>: The recording was automatically uploaded after a low impact.</li>
                                    <li><b>None</b>: You uploaded this video yourself.</li>
                                </ul>
                                <div>This is to help you identify and tag the importance of the recording.</div>
                            </ReactToolTip>
                        </label>
                        <select
                            id="lstPriority"
                            className="form-control input-lg"
                            value={this.state.priority}
                            onChange={event => this.setState(byPropKey('priority', event.target.value))}
                            disabled={!this.props.editModeOn || true}
                        >
                            <option value={PRIORITY_HIGH}>High</option>
                            <option value={PRIORITY_MEDIUM}>Med</option>
                            <option value={PRIORITY_LOW}>Low</option>
                            <option value={PRIORITY_NONE}>None</option>
                        </select>
                    </div>
                }
                {
                    (this.props.editModeOn) &&
                    <div className="form-group form-inline">
                        <label className="mr-1" htmlFor="lstPrivacy">
                            Privacy <span data-tip data-for={TOOLTIP_PRIVACY_ID}><i className="ml-1 far fa-question-circle"/></span>:
                            <ReactToolTip id={TOOLTIP_PRIVACY_ID}>
                                <div>The privacy level of the recording.</div>
                                <ul>
                                    <li><b>Public</b>: Anyone with access to the shared link can view, but not edit the recording.</li>
                                    <li><b>Private</b>: Only you can view/edit the recording.</li>
                                </ul>
                            </ReactToolTip>
                        </label>
                        <select
                            id="lstPrivacy"
                            className="form-control input-lg"
                            value={this.state.privacy}
                            onChange={event => this.setState(byPropKey('privacy', event.target.value))}
                            disabled={!this.props.editModeOn}
                        >
                            <option value={PRIVACY_PUBLIC}>Public</option>
                            <option value={PRIVACY_PRIVATE}>Private</option>
                        </select>
                    </div>
                }
                {
                    !this.props.editModeOn &&
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12"><PriorityLevel rawPriority={this.props.recording.priority}/></div>
                        <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12"><PrivacyLevels rawPrivacy={this.props.recording.privacy}/></div>
                        <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12"><Runtime runtime={this.props.recording.runtime}/></div>
                        <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12"><Size size={this.props.recording.size}/></div>
                        <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12"><Speed speed={this.props.recording.speed}/></div>
                    </div>
                }
                {
                    this.props.editModeOn &&
                    <div className="text-center">
                        <button className="btn btn-success mr-2" onClick={this.props.saveChanges}><i className="far fa-save"/> Save</button>
                        <button className="btn btn-warning" onClick={this.props.offEditMode}><i className="fas fa-times"/> Cancel</button>
                    </div>
                }
                {
                    this.state.error &&
                    <p>{this.state.error.message}</p>
                }
            </form>
        ) : null;
    }
}

export default RecordingForm;



// WEBPACK FOOTER //
// ./src/components/recording/RecordingForm.jsx